<template>
  <div>
    <!-- 新增按钮 -->
    <a-row :gutter="24">
      <a-col :span="12" style="margin: 10px">
        <a-button type="primary" @click="openAddVisible">
          新增优先承租人
        </a-button>
      </a-col>
    </a-row>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :data-source="fileList"
      :pagination="false"
      :scroll="{ x: 950 }"
      rowKey="id"
    >
      <span slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>

      <span slot="action" slot-scope="text, record, index">
        <a style="color: #1890ff" @click="editRow(record, index)">编辑</a>
        <a-divider type="vertical" />
        <a style="color: #1890ff" @click="viewRow(record)">查看</a>
        <a-divider type="vertical" />
        <a style="color: #1890ff" @click="deleteRow(index)">删除</a>
      </span>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :visible="addVisible"
      :footer="null"
      width="800px"
      @cancel="closeAddModule"
      destroyOnClose
    >
      <h2 class="title">新增优先承租人</h2>
      <a-form-model
        ref="formRef"
        :model="priorityFormData"
        :rules="priorityRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        class="add-lessee"
      >
        <!-- 优先承租人类型 -->
        <a-form-model-item label="优先承租人类型" prop="priorityLesseeType">
          <a-radio-group v-model="priorityFormData.priorityLesseeType">
            <a-radio value="A11001">法人或其分支机构、其他经济组织</a-radio>
            <a-radio value="A11002">自然人</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 优先承租人名称 -->
        <a-form-model-item label="优先承租人名称" prop="priorityLesseeName">
          <a-input
            v-model="priorityFormData.priorityLesseeName"
            placeholder="请输入优先承租人名称"
          />
        </a-form-model-item>

        <!-- 统一社会信用代码 -->
        <a-form-model-item
          label="统一社会信用代码"
          prop="certCode"
          v-if="priorityFormData.priorityLesseeType == 'A11001'"
        >
          <a-input
            v-model="priorityFormData.certCode"
            placeholder="请输入统一社会信用代码"
          />
        </a-form-model-item>

        <!-- 优先承租人证件类型 -->
        <a-form-model-item
          label="优先承租人证件类型"
          prop="certType"
          v-if="priorityFormData.priorityLesseeType == 'A11002'"
        >
          <a-radio-group v-model="priorityFormData.certType">
            <a-radio style="margin: 4px 0px" :value="0">身份证</a-radio>
            <a-radio style="margin: 4px 0px" :value="1">护照</a-radio>
            <a-radio style="margin: 4px 0px" :value="2">军官证</a-radio>
            <a-radio style="margin: 4px 0px" :value="3">士兵证</a-radio>
            <a-radio style="margin: 4px 0px" :value="4">回乡证</a-radio>
            <a-radio style="margin: 4px 0px" :value="5">户口本</a-radio>
            <a-radio style="margin: 4px 0px" :value="6">外国护照</a-radio>
            <a-radio style="margin: 4px 0px" :value="15">台胞证</a-radio>
            <a-radio style="margin: 4px 0px" :value="16"
              >港澳台居民身份证</a-radio
            >
            <a-radio style="margin: 4px 0px" :value="99">其它</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 证件编号 -->
        <a-form-model-item
          label="证件编号"
          prop="certCode"
          v-if="priorityFormData.priorityLesseeType == 'A11002'"
        >
          <a-input
            v-model="priorityFormData.certCode"
            placeholder="请输入证件编号"
          />
        </a-form-model-item>

        <!-- 按钮 -->
        <a-form-model-item
          :wrapper-col="{ span: 24 }"
          style="text-align: center"
        >
          <a-button style="margin-right: 16px" @click="closeAddModule">
            关闭
          </a-button>
          <a-button type="primary" @click="submitForm"> 确定 </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "优先承租人名称",
    dataIndex: "priorityLesseeName",
    width: 260,
  },
  {
    title: "优先承租人类型",
    dataIndex: "priorityLesseeType",
    width: 260,
  },
  {
    title: "证件编号",
    dataIndex: "certCode",
    width: 280,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    fixed: "right",
    width: 200,
  },
];

export default {
  name: "PriorityLessee",
  data() {
    return {
      columns,
      addVisible: false,
      editIndex: null, // 用于区分新增 / 编辑

      fileList: [
        {
          priorityLesseeName: "上海市金山区供销合作社",
          priorityLesseeType: "法人或其分支机构、其他经济组织",
          certCode: "91310116134228393K",
        },
      ],

      priorityFormData: {
        priorityLesseeType: "A11001",
        priorityLesseeName: "",
        certType: 0,
        certCode: "",
      },

      priorityRules: {
        priorityLesseeType: [
          {
            required: true,
            message: "请选择优先承租人类型",
            trigger: "blur",
          },
        ],
        priorityLesseeName: [
          { required: true, message: "请输入优先承租人名称", trigger: "blur" },
        ],
        certType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        certCode: [
          { required: true, message: "请输入统一信用代码/证件编号", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 打开新增
    openAddVisible() {
      this.editIndex = null;
      this.addVisible = true;
    },

    // 关闭弹窗
    closeAddModule() {
      this.addVisible = false;
    },

    // 提交
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        // ...
      });
    },

    // 点击编辑
    editRow(row, index) {
      this.editIndex = index;
      this.formData.type = row.priorityLesseeType === "自然人" ? 2 : 1;
      this.formData.name = row.priorityLesseeName;
      this.formData.certCode = row.certCode;
      this.addVisible = true;
    },

    // 查看
    viewRow(row) {},

    // 删除
    deleteRow(index) {
      this.$confirm({
        title: "确认删除？",
        content: "删除后不可恢复",
        onOk: () => {
          this.fileList.splice(index, 1);
          this.$message.success("删除成功");
        },
      });
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}
.add-lessee /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
